// 文件类型
export enum FileType {
  IMAGE = 1, // 图片
  VIDEO = 2, // 视频
}

// 上传标记
export enum UploadFileMark {
  DEFAULT = 1, // 默认
  CLASS_VIDEO = 4, // 课堂视频
  FACE_PHOTO = 5, // 人脸照片
  MERCHANT_WORK = 6, // 商户作品
}

// 课堂视频媒体类型（获取 OSS 配置时透传）
export enum OssMediaType {
  ClassVideo = 1, // 正常课堂视频
  PreviewVideo = 2, // 预告片
}

// oss配置
export type OssConfigData = {
  access_key_id: string;
  access_key_secret: string;
  security_token: string;
  expiration: number;
  bucket_name: string;
  path: string;
  after_path: string;
  file_id: string;
  url: string;
  /** Base64 编码的 OSS 回调配置；存在时表示启用公共目录转码 */
  callback_base64?: string;
};

/** OSS 回调配置（由 callback_base64 解码得到） */
export type OssCallbackConfig = {
  callbackUrl: string;
  callbackBody: string;
  callbackBodyType: string;
};

/** OSS 上传回调响应 */
export type OssCallbackResponse = {
  output_url?: string;
};

// 配置信息
export type ConfigData = {
  now_time: string;
};
